import { baseClient } from '@store/index';
import { TelnyxVoiceApp, UpdateVoiceWebhookParams, VoiceAppNumber, VoiceCallCredential } from './';
import { QueryFunctionContext } from '@tanstack/react-query';

export const getVoiceApplications = async (): Promise<TelnyxVoiceApp[]> => {
  const url = '/telnyx/call_control_applications';
  const response = await baseClient.get<TelnyxVoiceApp[]>(url);
  const voiceApplications = response.data;

  return voiceApplications.sort((a, b) => {
    if (a?.outbound?.outbound_voice_profile_id && !b?.outbound?.outbound_voice_profile_id) return -1;
    else return 1;
  });
};

export const getCallCredentials = async (): Promise<VoiceCallCredential[]> => {
  const url = '/telnyx/call_credentials';
  const response = await baseClient.get<VoiceCallCredential[]>(url);
  const callCredentials = response.data;

  return callCredentials.sort((a, b) => {
    if (a?.outbound?.outbound_voice_profile_id && !b?.outbound?.outbound_voice_profile_id) return -1;
    else return 1;
  });
};

export const getNumberByConnectionId = async ({
  queryKey,
}: QueryFunctionContext<[string, string]>): Promise<VoiceAppNumber[]> => {
  const [, connectionId] = queryKey;

  const url = `/telnyx/phone_numbers/connection/${connectionId}`;
  const response = await baseClient.get<VoiceAppNumber[]>(url);
  const phoneNumbers = response.data;
  return phoneNumbers;
};

export const updateVoiceAppWebhook = async ({ connectionId, service_id, workflow_id }: UpdateVoiceWebhookParams) => {
  const url = `/telnyx/call_control_applications/${connectionId}/webhook`;
  const response = await baseClient.patch(url, { service_id, workflow_id });
  return response.data;
};
